import itemTypeAllComponent from './item_type.all.component';

let itemTypeAllModule = angular.module('itemTypeAll', [])

  .component('itemTypeAll', itemTypeAllComponent)
  .name;

export default itemTypeAllModule;


// WEBPACK FOOTER //
// ./client/app/components/item_type/all/index.js